import { gql } from "urql";
export const GetFamilyRoomPatientsQuery = gql `
    query GetFamilyRoomPatients($search: String) {
        patients {
            familyRoomPatients(search: $search) {
                patientId
                firstName
                lastName
                caregiver {
                    userId
                    firstName
                    lastName
                }
            }
        }
    }
`;
